import { ISearchManager, AbstractSubscriber, AbstractSearchCore, UrlSearchCore, IFacet } from '.'
import { config } from '../../constants'
import { Emitter } from '../emitter'
export class SearchManager implements ISearchManager {
  public static DEFAULT_GROUP_ID = '__default__'
  searchCores: AbstractSearchCore[] = []
  private _ee: Emitter | null = null

  public async subscribe(subscriber: AbstractSubscriber): Promise<void> {
    if (!subscriber.getGroupId()) {
      subscriber.setGroupId(SearchManager.DEFAULT_GROUP_ID)
    }

    let searchCore = this.searchCores.find((value: AbstractSearchCore) => {
      return value.getGroupId() === subscriber.getGroupId()
    })

    const coreConfig: {
      index: string[]
      facetsAgnosticIndex: string[]
      defaultQuery: string
      defaultFacets: IFacet[]
      indexesWithGeo: string[]
      indexesWithEmptyQuery: string[]
      hitsPerPage: { [indexName: string]: number }
      configs: { [indexName: string]: any }
    } =
      window?.LVC_SEARCH_CONFIGS?.searchCoreConfigs?.[subscriber.getGroupId()] ??
      window?.LVC_SEARCH_CONFIGS?.searchCoreConfigs?.defaultCoreConfig ??
      {}

    if (!searchCore) {
      const SearchCoreFactoryRef = UrlSearchCore

      searchCore = new SearchCoreFactoryRef(subscriber.getGroupId(), {
        appId: config.algolia.appId,
        apiKey: import.meta.env.VITE_ALGOLIA_API_KEY || '',
        appUrl: config.algolia.appUrl,
        index: coreConfig?.index,
        facetsAgnosticIndex: coreConfig?.facetsAgnosticIndex || [],
        defaultQuery: coreConfig?.defaultQuery || '',
        defaultFacets: coreConfig?.defaultFacets || [],
        indexesWithGeo: coreConfig?.indexesWithGeo || [],
        indexesWithEmptyQuery: coreConfig?.indexesWithEmptyQuery,
        configs: {
          hitsPerPage: coreConfig?.hitsPerPage || {},
          ...(coreConfig?.configs || {}),
        },
      })
      this.searchCores.push(searchCore)
    }

    this._ee = new Emitter()
    this._ee.on('lvc:user_state_changed', (radius: number) => {})
    // get the user's profile data to get his preferred radius

    searchCore.subscribe(subscriber)
  }

  public unsubscribe(subscriber: AbstractSubscriber): void {
    let searchCore = this.searchCores.find((value: AbstractSearchCore) => {
      return value.getGroupId() === subscriber.getGroupId()
    })

    if (!searchCore) return

    searchCore.unsubscribe(subscriber)

    if (searchCore.countSubscribers() <= 0) {
      const index = this.searchCores.indexOf(searchCore)

      if (index !== -1) {
        searchCore.destroy()
        this.searchCores.splice(index, 1)
      }
    }
  }
}
